import { render, staticRenderFns } from "./ConversationCard.vue?vue&type=template&id=1642ffa0&scoped=true&"
import script from "./ConversationCard.vue?vue&type=script&lang=ts&"
export * from "./ConversationCard.vue?vue&type=script&lang=ts&"
import style0 from "./ConversationCard.vue?vue&type=style&index=0&id=1642ffa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1642ffa0",
  null
  
)

export default component.exports